import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Calendar({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <Calendar.Outline {...props} />
  ) : (
    <Calendar.Solid {...props} />
  );
}

Calendar.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M16.4421 12.5598C16.0279 12.5598 15.6921 12.8956 15.6921 13.3098C15.6921 13.724 16.0279 14.0598 16.4421 14.0598H16.4514C16.8656 14.0598 17.2014 13.724 17.2014 13.3098C17.2014 12.8956 16.8656 12.5598 16.4514 12.5598H16.4421Z"
          fill="currentColor"
        />
        <path
          d="M11.2546 13.3098C11.2546 12.8956 11.5904 12.5598 12.0046 12.5598H12.0139C12.4281 12.5598 12.7639 12.8956 12.7639 13.3098C12.7639 13.724 12.4281 14.0598 12.0139 14.0598H12.0046C11.5904 14.0598 11.2546 13.724 11.2546 13.3098Z"
          fill="currentColor"
        />
        <path
          d="M7.55786 12.5598C7.14365 12.5598 6.80786 12.8956 6.80786 13.3098C6.80786 13.724 7.14365 14.0598 7.55786 14.0598H7.56713C7.98134 14.0598 8.31713 13.724 8.31713 13.3098C8.31713 12.8956 7.98134 12.5598 7.56713 12.5598H7.55786Z"
          fill="currentColor"
        />
        <path
          d="M15.6921 17.1963C15.6921 16.7821 16.0279 16.4463 16.4421 16.4463H16.4514C16.8656 16.4463 17.2014 16.7821 17.2014 17.1963C17.2014 17.6105 16.8656 17.9463 16.4514 17.9463H16.4421C16.0279 17.9463 15.6921 17.6105 15.6921 17.1963Z"
          fill="currentColor"
        />
        <path
          d="M12.0046 16.4463C11.5904 16.4463 11.2546 16.7821 11.2546 17.1963C11.2546 17.6105 11.5904 17.9463 12.0046 17.9463H12.0139C12.4281 17.9463 12.7639 17.6105 12.7639 17.1963C12.7639 16.7821 12.4281 16.4463 12.0139 16.4463H12.0046Z"
          fill="currentColor"
        />
        <path
          d="M6.80786 17.1963C6.80786 16.7821 7.14365 16.4463 7.55786 16.4463H7.56713C7.98134 16.4463 8.31713 16.7821 8.31713 17.1963C8.31713 17.6105 7.98134 17.9463 7.56713 17.9463H7.55786C7.14365 17.9463 6.80786 17.6105 6.80786 17.1963Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7937 2C16.7937 1.58579 16.4579 1.25 16.0437 1.25C15.6295 1.25 15.2937 1.58579 15.2937 2V2.8291H8.71558V2C8.71558 1.58579 8.37979 1.25 7.96558 1.25C7.55136 1.25 7.21558 1.58579 7.21558 2V2.84768C5.84497 2.94114 4.65167 3.38887 3.76749 4.22937C2.76004 5.18705 2.25 6.5633 2.25 8.22213V17.2718C2.25 18.9507 2.75774 20.3462 3.76225 21.3198C4.76302 22.2898 6.16301 22.7499 7.77096 22.7499H16.229C17.8377 22.7499 19.2366 22.2991 20.2371 21.3438C21.243 20.3834 21.75 19.0051 21.75 17.3474V8.22317C21.7548 6.56549 21.2504 5.18867 20.2448 4.23009C19.3619 3.3884 18.1677 2.94082 16.7937 2.84759V2ZM7.96558 6.04078C8.37979 6.04078 8.71558 5.70499 8.71558 5.29078V4.3291H15.2937V5.29078C15.2937 5.70499 15.6295 6.04078 16.0437 6.04078C16.4579 6.04078 16.7937 5.70499 16.7937 5.29078V4.35168C17.8534 4.44062 18.6561 4.78793 19.2098 5.31582C19.8507 5.92673 20.2541 6.87097 20.25 8.21982L20.25 8.22213V8.6543H3.75V8.22213C3.75 6.87387 4.1571 5.9286 4.80096 5.31654C5.3569 4.78806 6.15996 4.44097 7.21558 4.35182V5.29078C7.21558 5.70499 7.55136 6.04078 7.96558 6.04078ZM19.2013 20.2589C19.8444 19.6448 20.25 18.6968 20.25 17.3474V10.1543H3.75V17.2718C3.75 18.6472 4.1594 19.6158 4.8062 20.2427C5.45673 20.8732 6.44222 21.2499 7.77096 21.2499H16.229C17.5663 21.2499 18.5528 20.878 19.2013 20.2589Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Calendar.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 17.3698V9.75684H21V17.4308C21 20.5698 19.0241 22.4998 15.8628 22.4998H8.12733C4.99561 22.4998 3 20.5298 3 17.3698ZM7.95938 14.9098C7.50494 14.9308 7.12953 14.5698 7.10977 14.1108C7.10977 13.6508 7.46542 13.2708 7.91987 13.2498C8.36443 13.2498 8.72997 13.6008 8.73985 14.0498C8.7596 14.5108 8.40395 14.8908 7.95938 14.9098ZM12.0198 14.9098C11.5653 14.9308 11.1899 14.5698 11.1701 14.1108C11.1701 13.6508 11.5258 13.2708 11.9802 13.2498C12.4248 13.2498 12.7903 13.6008 12.8002 14.0498C12.82 14.5108 12.4643 14.8908 12.0198 14.9098ZM16.0505 18.5898C15.596 18.5798 15.2305 18.1998 15.2305 17.7398C15.2206 17.2798 15.5862 16.9008 16.0406 16.8908H16.0505C16.5148 16.8908 16.8902 17.2708 16.8902 17.7398C16.8902 18.2098 16.5148 18.5898 16.0505 18.5898ZM11.1701 17.7398C11.1899 18.1998 11.5653 18.5608 12.0198 18.5398C12.4643 18.5208 12.82 18.1408 12.8002 17.6808C12.7903 17.2308 12.4248 16.8798 11.9802 16.8798C11.5258 16.9008 11.1701 17.2798 11.1701 17.7398ZM7.09989 17.7398C7.11965 18.1998 7.49506 18.5608 7.94951 18.5398C8.39407 18.5208 8.74973 18.1408 8.72997 17.6808C8.72009 17.2308 8.35456 16.8798 7.90999 16.8798C7.45554 16.9008 7.09989 17.2798 7.09989 17.7398ZM15.2404 14.1008C15.2404 13.6408 15.596 13.2708 16.0505 13.2608C16.4951 13.2608 16.8507 13.6198 16.8705 14.0608C16.8804 14.5208 16.5247 14.9008 16.0801 14.9098C15.6257 14.9198 15.2503 14.5698 15.2404 14.1108V14.1008Z"
          className="icon-primary"
        />
        <path
          opacity="0.4"
          d="M3.00342 9.75675C3.01626 9.16975 3.06566 8.00475 3.15852 7.62975C3.63273 5.52075 5.24304 4.18075 7.54491 3.98975H16.456C18.7381 4.19075 20.3682 5.53975 20.8424 7.62975C20.9343 7.99475 20.9837 9.16875 20.9965 9.75675H3.00342Z"
          className="icon-secondary"
        />
        <path
          d="M8.30465 7.09C8.73934 7.09 9.06535 6.761 9.06535 6.32V3.271C9.06535 2.83 8.73934 2.5 8.30465 2.5C7.86996 2.5 7.54395 2.83 7.54395 3.271V6.32C7.54395 6.761 7.86996 7.09 8.30465 7.09Z"
          className="icon-primary"
        />
        <path
          d="M15.6948 7.09C16.1196 7.09 16.4555 6.761 16.4555 6.32V3.271C16.4555 2.83 16.1196 2.5 15.6948 2.5C15.2601 2.5 14.9341 2.83 14.9341 3.271V6.32C14.9341 6.761 15.2601 7.09 15.6948 7.09Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
